export default function ContactSection() {
  return (
    <section id="contact" className="py-16 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            联系与投稿
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            有漫画资源推荐或合作意向？欢迎随时联系我们
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
            <div className="p-6 rounded-xl bg-background-50 border border-background-200/60 text-center cursor-default">
              <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-primary-100 text-primary-500 mb-4">
                <i className="ri-mail-line text-xl"></i>
              </div>
              <h3 className="font-heading text-base text-foreground-900 mb-2">资源投稿</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                发现好漫画想推荐给大家？发送作品信息至我们的投稿邮箱，编辑团队会尽快审核收录。
              </p>
              <span className="inline-block mt-3 text-sm text-primary-500 font-medium whitespace-nowrap">
                submit@bika-comic.com
              </span>
            </div>

            <div className="p-6 rounded-xl bg-background-50 border border-background-200/60 text-center cursor-default">
              <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-accent-100 text-accent-500 mb-4">
                <i className="ri-chat-smile-2-line text-xl"></i>
              </div>
              <h3 className="font-heading text-base text-foreground-900 mb-2">意见反馈</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                使用过程中遇到任何问题或有改进建议？你的每一条反馈都是我们进步的动力。
              </p>
              <span className="inline-block mt-3 text-sm text-accent-500 font-medium whitespace-nowrap">
                feedback@bika-comic.com
              </span>
            </div>

            <div className="p-6 rounded-xl bg-background-50 border border-background-200/60 text-center cursor-default">
              <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-secondary-100 text-secondary-500 mb-4">
                <i className="ri-briefcase-line text-xl"></i>
              </div>
              <h3 className="font-heading text-base text-foreground-900 mb-2">商务合作</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                品牌推广、广告投放、IP联动等商务合作需求，欢迎来函详谈合作方案。
              </p>
              <span className="inline-block mt-3 text-sm text-secondary-500 font-medium whitespace-nowrap">
                biz@bika-comic.com
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}